/**
 * isQgame
 * @author marvinqi
 * @createTime 2017/9/20
 */
import getUA from './getUA'

export default function () {
  return /\bcom\.tencent\.qgame\/([\d\.]+)/.test(getUA())
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/isQgame.js